define('helpers/modelHelpers',['require','exports','module'],function(require, exports, module) {
    "use strict";

    var classifyCompanies = function(companies) {
        var masterCompanies = [];
        var standardCompanies = [];

        _.each(companies, function(company) {
            if (company.name.toUpperCase() === 'MASTER') {
                masterCompanies.push(company);
            } else {
                standardCompanies.push(company);
            }
        });

        return { master: masterCompanies, standard: standardCompanies };
    };

    var modelHelpers = {    
        getCompaniesSorted: function(companies) {
            var classifiedCompanies = classifyCompanies(companies);
            var standardCompaniesSorted = _.sortBy(classifiedCompanies.standard, function(company){
                return company.name.toUpperCase();
            });

            return classifiedCompanies.master.concat(standardCompaniesSorted);
        },
    };

    module.exports = modelHelpers;
});

